export default "__VITE_ASSET__BTu24t75__"